import React from 'react';
import * as actionTypes from '../redux/actionTypes';

import { getAddCardAPIInfo, getDeleteCardInfo, getSaveCardAPIInfo, getSimpleSaveCardInfo } from '../join-commute/helpers/vanHelpers';
import { getCardDetails, isCardExpired, sortCardForDisplay } from '../payment/helper';
import { useEffect, useRef, useState } from 'react';
import config from '../appConfig';
import AddCard from './card-operations/AddCard';
import AddIcon from '../_styles/images/AddIcon.png';
import ArrowLeft from '../_styles/images/ArrowLeft.png';
import BackupCard from './card-operations/BackupCard';
import CardBox from './card-operations/CardBox';
import CardMessage from './card-operations/CardMessage';
import ConfirmationPopup from './card-operations/common/delete-confirmation/ConfirmationPopup';
import EditCard from './card-operations/EditCard';
import { Link } from 'react-router-dom';
import SelectCard from './card-operations/SelectCard';
import ToastMessage from './card-operations/common/toast-message/ToastMessage';
import { connect } from 'react-redux';
import { getCardInfo } from './helper';
import { verifyCard } from './payments/paymentsSaga';
import { isEmpty } from 'lodash';
import useError from '../shared/components/error-screen/useError';
import analyticsService from '../shared/analytics/analytics-service';
import Loading from '../shared/loading/Loading';
import SecondaryCardNoticePopup from '../profile/components/change-subscription/upgrade-section/SecondaryCardNoticePopup';
import MakeOriginalRetailAsBackup from './card-operations/MakeOriginalRetailAsBackup';
import CardReplacementConfirmPopup from './card-operations/CardReplacementConfirmPopup';

function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}

function PaymentCards(props) {
  const addCardNode = useRef(null);
  const addBackupCardNode = useRef(null);
  const addNewBackupCardNode = useRef(null);
  const editCardNode = useRef(null);
  const selectBackupNode = useRef(null);
  const selectBackupNode1 = useRef(null);
  const deleteCardNode = useRef();
  const selectCardAlertNode = useRef();
  const addBackupAlertNode = useRef();
  const selectPrimaryCardAlertNode = useRef();
  const selectPrimaryCardNode = useRef();
  const AddReplacementPrimaryCardAlertNode = useRef();
  const ShowPaymentCardRequiredAlertNode = useRef();
  const ShowMakeOriginalRetailAlertNode = useRef();
  const AddReplacementPrimaryCardNode = useRef();
  const AddReplacementBackupCardNode = useRef();
  const selectBackupAsPrimaryAlertNode = useRef();
  const selectBackupAsPrimaryCardNode = useRef();
  const AddBackupAlertWhenDeletingFederalNode = useRef();

  const [payments, updatePayments] = useState([]);
  const [loading, updateLoading] = useState(false);
  const [showAddCard, updateShowAddCard] = useState(false);
  const [cardsDetails, updateCardsDetails] = useState(null);
  const [showAddBackupCard, updateShowBackupAddCard] = useState(false);
  const [primaryCardVerifyInfo, updatePrimaryCardVerifyInfo] = useState({});
  const [primaryCardApiInfo, updatePrimaryCardApiInfo] = useState({});
  const [showEditCard, updateShowEditCard] = useState(false);
  const [currentEditCard, updateCurrentEditCard] = useState({});
  const [showBackupCard, updateShowBackupCard] = useState(false);
  const [showSelectBackupCard, updateShowSelectBackupCard] = useState(false);
  const [showDeleteCardAlert, updateShowDeleteCardAlert] = useState(false);
  const [showSelectCardAlert, updateShowSelectCardAlert] = useState(false);
  const [cardsToSelectFrom, updateCardsToSelectFrom] = useState([]);
  const [showAddBackupAlert, updateShowAddBackupAlert] = useState(false);
  const [showAddNewBackupCard, updateShowAddNewBackupCard] = useState(false);
  const [showSelectPrimaryCardAlert, updateShowSelectPrimaryCardAlert] = useState(false);
  const [showSelectBackupAsPrimaryAlert, updateShowSelectBackupAsPrimaryAlert] = useState(false);
  const [showSelectPrimaryCard, updateShowSelectPrimaryCard] = useState(false);
  const [showSelectBackupAsPrimary, updateShowSelectBackupAsPrimary] = useState(false);
  const [showAddReplacementPrimaryCardAlert, updateShowAddReplacementPrimaryCardAlert] = useState(false);
  const [showPaymentCardRequiredAlert, updateShowPaymentCardRequiredAlert] = useState(false);
  const [showMakeOriginalRetailAlert, updateShowMakeOriginalRetailAlert] = useState(false);
  const [showAddReplacementPrimaryCard, updateShowAddReplacementPrimaryCard] = useState(false);
  const [showAddReplacementBackupCard, updateShowAddReplacementBackupCard] = useState(false);
  const [isVanStartingInFuture, updateIsVanStartingInFuture] = useState(null);
  const [isVanCancelled, updateIsVanCancelled] = useState(null);
  const [secondryCardLoading, updateSecondryCardLoading] = useState(false);
  const [showSCRPopup, updateShowSCRPopup] = useState(false);
  const [fromCS,  updateFromCS] = useState(false);
  const [isDriverPending, updateDriverPending] = useState(false);
  const [newReplacementPrimaryCardDetails, updateNewReplacementPrimaryCardDetails] = useState(null);
  const [deletingRetailPrimary, updateDeletingRetailPrimary] = useState(false);
  const [maxAuthorizedAmountIsLess, updateMaxAuthorizedAmountIsLess] = useState(false);
  const [isDeleteScenario, updateIsDeleteScenario] = useState(false);
  const [showAddBackupAlertWhenDeletingFederal, updateShowAddBackupAlertWhenDeletingFederal] = useState(false);
  const [isDeleteBackupScenario,updateIsDeleteBackupScenario] = useState(false);
  const [addingNewbenefitCard, updateAddingNewBenefitCard] =  useState(false);
  const [newBenefitCard, updateNewBenefitCard] =  useState(null);
  const [isEditScenario, updateIsEditScenario] = useState(false);
  const [editCardDetails, updateEditDetails] = useState(null);
  const [editDeleteFederal, updateEditDeleteFederal] = useState(false);
  const [replacingRetailPrimaryCardwithBenefit, updateReplacingRetailPrimaryCardwithBenefit] = useState(false);
  const [showReplacementConfirmModal, updateShowReplacementConfirmModal] = useState(false);
  const [deleteRetailPrimaryData, updateDeleteRetailPrimaryData] = useState(false);
  const [addBackupWhileDeletingRetailPrimary, updateAddBackupWhileDeletingRetailPrimary] = useState(false);

  useOnClickOutside(deleteCardNode, () => updateShowDeleteCardAlert(false));
  useOnClickOutside(editCardNode, () => updateShowEditCard(false));
  useOnClickOutside(addCardNode, () => updateShowAddCard(false));
  useOnClickOutside(addBackupCardNode, () => updateShowBackupAddCard(false));
  useOnClickOutside(addNewBackupCardNode, () => updateShowAddNewBackupCard(false));
  useOnClickOutside(selectBackupNode, () => updateShowBackupCard(false));
  useOnClickOutside(selectBackupNode1, () => updateShowSelectBackupCard(false));
  useOnClickOutside(selectCardAlertNode, () => updateShowSelectBackupCard(false));
  useOnClickOutside(addBackupAlertNode, () => updateShowAddBackupAlert(false));
  useOnClickOutside(selectPrimaryCardAlertNode, () => updateShowSelectPrimaryCardAlert(false));
  useOnClickOutside(selectPrimaryCardNode, () => updateShowSelectPrimaryCard(false));
  useOnClickOutside(AddReplacementPrimaryCardAlertNode, () => updateShowAddReplacementPrimaryCardAlert(false));
  useOnClickOutside(ShowPaymentCardRequiredAlertNode, () => updateShowPaymentCardRequiredAlert(false));
  useOnClickOutside(ShowMakeOriginalRetailAlertNode, () => updateShowMakeOriginalRetailAlert(false));
  useOnClickOutside(AddReplacementPrimaryCardNode, () => updateShowAddReplacementPrimaryCard(false));
  useOnClickOutside(AddReplacementBackupCardNode, () => updateShowAddReplacementBackupCard(false));
  useOnClickOutside(selectBackupAsPrimaryAlertNode, () => updateShowSelectBackupAsPrimaryAlert(false));
  useOnClickOutside(selectBackupAsPrimaryCardNode, () => updateShowSelectBackupAsPrimary(false));
  useOnClickOutside(AddBackupAlertWhenDeletingFederalNode, () => updateShowAddBackupAlertWhenDeletingFederal(false));

  useEffect(() => {
    updateLoading(true);
    props.init();
    props.getBINNumbers();
    if(!props.isProfileLoaded){
      props.loadProfile();
    }
    if(props.history && props.history.location && props.history.location.state && props.history.location.state.fromChangeSubscription){
      updateFromCS(true)
    }
  }, []);

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${config.jsScramblerLink}"]`);
    //document.querySelector(`script[src="${scriptSrc}"]`);
    const script = document.createElement('script');
    if (!existingScript) {
      // Append script
      script.src = config.jsScramblerLink;
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
    }
    // Cleanup: remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, [])

  useError(props.loadError, props.history, props.loadErrorString);

  useEffect(() => {
    if (props.paymentDetailsLoaded && props.isProfileLoaded) {
      updateLoading(false);
      if (props && props.payment && props.payment.cards && props.payment.cards.length > 0) {
        const sortedCards = sortCardForDisplay(props.payment.cards);
        updatePayments(sortedCards);
        const cardDetails = getCardDetails(props.payment.cards);
        updateCardsDetails(cardDetails);
        updateLoading(false);
      } else if (props.payment.cards && props.payment.cards.length === 0) {
        const cardDetails = {
          federal: 0,
          retail: 0,
          commuter: 0
        };
        updateCardsDetails(cardDetails);
      }
      if(props && props.profile && props.profile.subscription){
        updateIsVanStartingInFuture(props.profile.subscription.isVanStartingInFuture);
      }
      if(props && props.profile && props.profile.subscription){
        updateIsVanCancelled(props.profile.subscription.isVanCancelled);
      }
      updateDeletingRetailPrimary(false);
      updateMaxAuthorizedAmountIsLess(false);
      updateIsDeleteScenario(false);
      updateIsDeleteBackupScenario(false);
      updateAddingNewBenefitCard(false);
      updateNewBenefitCard(null);
      updateIsEditScenario(false);
      updateEditDeleteFederal(false);
      updateReplacingRetailPrimaryCardwithBenefit(false);
      updateAddBackupWhileDeletingRetailPrimary(false);
    }
  }, [props.paymentDetailsLoaded, props.payment.cards, props.isProfileLoaded]);

  useEffect(() => {
    if(showDeleteCardAlert){
      analyticsService.analyticsProcessEvent({
        "event": "modal_view_generic",
        "context": {
          "event_action": "delete card? modal"
        }
      });
    }
    if(showAddBackupAlert){
      analyticsService.analyticsProcessEvent({
        "event": "modal_view_generic",
        "context": {
          "event_action": "add another backup card modal"
        }
      });
    }
  },[showDeleteCardAlert, showAddBackupAlert])

  function editCard(card) {
    updateCurrentEditCard(card);
    updateShowEditCard(true);
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "edit"
      }
    });
  }

  function setVerifyApiInfo(cardProps) {
    const primCardInfo = getCardInfo(cardProps);
    const primVerifyInfo = getSaveCardAPIInfo(primCardInfo);
    const primApiInfo = getAddCardAPIInfo(primCardInfo);
    updateNewBenefitCard(primCardInfo);
    updatePrimaryCardApiInfo(primApiInfo);
    updatePrimaryCardVerifyInfo(primVerifyInfo);
    updateNewReplacementPrimaryCardDetails(cardProps)
  }

  function addCard(cardProps) {
    updateShowAddCard(false);
    updateShowBackupAddCard(false);
    if (cardProps.isFederal || cardProps.isCommuter) {
      setVerifyApiInfo(cardProps);
      updateLoading(true);
      updateAddingNewBenefitCard(true);
      saveCard(cardProps);
    } else {
      updateLoading(true);
      saveCard(cardProps);
    }
  }

  async function addBackupCard(cardProps, deleteCard) {
    updateLoading(true);
    updateShowBackupAddCard(false);
    const backupCardInfo = getCardInfo(cardProps);
    const backupVerifyInfo = getSaveCardAPIInfo(backupCardInfo);
    const backupApiInfo = getAddCardAPIInfo(backupCardInfo);
    const primaryCardData = await verifyCard(primaryCardVerifyInfo, primaryCardApiInfo);
    const backupCardData = await verifyCard(backupVerifyInfo, backupApiInfo);
    if (!isEmpty(primaryCardData) && !isEmpty(backupCardData)) {
      props.addCards(primaryCardData, backupCardData, deleteCard, fromCS);
    }
  }

  function saveCard(cardProps, deleteCardInfo, editDeleteFederal) {
    const cardInfo = getCardInfo(cardProps);
    const verifyCardInfo = getSaveCardAPIInfo(cardInfo);
    const apiCardInfo = getAddCardAPIInfo(cardInfo);
    if(deleteCardInfo){
      props.saveCard(verifyCardInfo, apiCardInfo, deleteCardInfo, fromCS);
    }else{
      props.saveCard(verifyCardInfo, apiCardInfo, null, fromCS, editDeleteFederal);
    }
  }

  function saveEditedCard(cardData) {
    updateLoading(true);
    updateIsEditScenario(true);
    updateEditDetails(cardData);
    props.saveEditedCard(cardData, fromCS);
    updateShowEditCard(false);
  }

  function saveClicked() {
    updateLoading(true);
    updateShowBackupCard(false);
    props.saveCard(primaryCardVerifyInfo, primaryCardApiInfo, fromCS);
  }



  async function deleteClicked() {
    updateShowEditCard(false);
    if (currentEditCard.isPrimary && !currentEditCard.isFederalBenefitCard && !currentEditCard.isCommuterBenefitCard) {
      //when user is deleting a retail primary card
      if (cardsDetails.extraCards.retail.length === 0) {
        updateDeletingRetailPrimary(true)
       // updateShowAddReplacementPrimaryCardAlert(true); removing this as part of new chnages for using same existing card as secondary
       if(cardsDetails.retailCards && cardsDetails.retailCards[0].isPrimary){
        updateCardsToSelectFrom(cardsDetails.retailCards);
       }
       updateShowPaymentCardRequiredAlert(true);
        analyticsService.analyticsProcessEvent({
          "event": "modal_view_generic",
          "context": {
            "event_action": "add another card modal"
          }
        });
      } else if (cardsDetails.extraCards.retail.length > 0) {
        updateShowSelectPrimaryCardAlert(true);
      }
    } else if (currentEditCard.isPrimary && (currentEditCard.isFederalBenefitCard || currentEditCard.isCommuterBenefitCard)) {
      //when user is deleting a federal/commuter primary card
      // if(cardsDetails.backupCards.length > 0){ -  chnaging to show all retails cards to select
        if(cardsDetails.extraRetailWithBackupCards.length > 0){
        updateShowSelectBackupAsPrimaryAlert(true);
      }else {
        updateIsDeleteScenario(true)
        updateShowAddReplacementPrimaryCardAlert(true);
      }
     
    } else {
       //when user is deleting a backup card (can only be retail card)
       updateShowDeleteCardAlert(true);
       updateIsDeleteBackupScenario(true)
    }
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "delete card"
      }
    });
  }

  useEffect(() => {
    if(props.showCardAlert){
      updateLoading(false);
      props.updateShowCardAlert(false);
      if(deletingRetailPrimary){
        updateShowMakeOriginalRetailAlert(true);
      } else if (cardsDetails && cardsDetails.extraCards && cardsDetails.extraCards.retail.length > 0) {
          updateShowSelectCardAlert(true);
      } else {
        if(isDeleteScenario){ // enable this if popup text is changing
          updateShowAddBackupAlertWhenDeletingFederal(true);
        }else{
          updateShowAddBackupAlert(true);
        }
      }
    }

  }, [props.showCardAlert]);

  function deleteConfirmed() {
    updateShowDeleteCardAlert(false);
    deleteCard();
    analyticsService.analyticsProcessEvent({
      "event": "modal_click_generic",
      "context": {
        "event_action": "delete",
        "event_detail": {
          "modal": "delete card? modal"
        }  
      }
    });
  }

  function selectConfirmed() {
    updateShowSelectCardAlert(false);
    if (cardsDetails && cardsDetails.extraCards && cardsDetails.extraCards.retail) {
      updateCardsToSelectFrom(cardsDetails.extraCards.retail);
      updateShowSelectBackupCard(true);
    }
    analyticsService.analyticsProcessEvent({
      "event": "modal_click_generic",
      "context": {
        "event_action": "select card",
        "event_detail": {
          "modal": "Select another backup card modal"
        }  
      }
    });
  }

  function deleteCard() {
    updateLoading(true);
    const deleteCardInfo = getDeleteCardInfo(currentEditCard);
    props.deleteCard(deleteCardInfo, fromCS);
  }

  //calling this when we are adding a federal card with less amount and selecting card from file for backup.
  async function saveBackupClicked(backupCard) {
    updateShowSelectBackupCard(false);
    updateShowMakeOriginalRetailAlert(false);
    updateLoading(true);
    if((replacingRetailPrimaryCardwithBenefit || addingNewbenefitCard) && primaryCardVerifyInfo && primaryCardApiInfo){
      const selectBackup =  true;
      const backupSaveInfo = getSimpleSaveCardInfo(backupCard, false, true);
      const primaryCardData = await verifyCard(primaryCardVerifyInfo, primaryCardApiInfo);
      if (!isEmpty(primaryCardData) && !isEmpty(backupCard)) {
        props.addCardsWithMaxAmountLess(primaryCardData, backupSaveInfo, null, fromCS, selectBackup);
      }
    } else if(isEditScenario && editCardDetails){ 
      const selectBackup =  true;
      const backupSaveInfo = getSimpleSaveCardInfo(backupCard, false, true);
      props.saveBackupWhenEditingCard(editCardDetails, backupSaveInfo,fromCS, selectBackup);
    }else {
      const saveInfo = getSimpleSaveCardInfo(backupCard, false, true);
      const deleteCardInfo = getDeleteCardInfo(currentEditCard);
      props.simpleSaveCard(saveInfo, deleteCardInfo, fromCS);
    }

  }


//calling this when we are adding a federal card with less amount and adding a new card for backup.
  function addBackupAlertConfirmed() {
    updateShowAddBackupAlert(false);
    updateShowAddNewBackupCard(true);
    updateShowAddBackupAlertWhenDeletingFederal(false) //enabled this for popup text is changing
    analyticsService.analyticsProcessEvent({
      "event": "modal_click_generic",
      "context": {
        "event_action": "add card",
        "event_detail": {
          "modal": "add another card"
        }  
      }
    });
  }

  //change the scenario here to call backup card first then federal or delete a secondary card and add new
  async function addNewBackupCard(cardProps) {
    updateLoading(true);
    updateShowAddNewBackupCard(false);
    const deleteCardInfo = getDeleteCardInfo(currentEditCard);
    if(isDeleteBackupScenario){
      saveCard(cardProps, deleteCardInfo);
    }else if(isEditScenario && editCardDetails) {
      const backupCardInfo = getCardInfo(cardProps);
      const backupVerifyInfo = getSaveCardAPIInfo(backupCardInfo);
      const backupApiInfo = getAddCardAPIInfo(backupCardInfo);
      const backupCardData = await verifyCard(backupVerifyInfo, backupApiInfo);
      props.saveBackupWhenEditingCard(editCardDetails, backupCardData,fromCS);
    } else {
      const backupCardInfo = getCardInfo(cardProps);
      const backupVerifyInfo = getSaveCardAPIInfo(backupCardInfo);
      const backupApiInfo = getAddCardAPIInfo(backupCardInfo);
      const primaryCardData = await verifyCard(primaryCardVerifyInfo, primaryCardApiInfo);
      const backupCardData = await verifyCard(backupVerifyInfo, backupApiInfo);
      if (!isEmpty(primaryCardData) && !isEmpty(backupCardData)) {
        if( !deletingRetailPrimary && (currentEditCard.isPrimary && (currentEditCard.isCommuterBenefitCard || currentEditCard.isFederalBenefitCard)) ||  !deletingRetailPrimary && (newBenefitCard && (newBenefitCard.isFederal || (newBenefitCard.isCommuter || newBenefitCard.isCommuterBenefitCard)))){
          props.addCardsWithMaxAmountLess(primaryCardData, backupCardData, null, fromCS, null, editDeleteFederal);
        }else{
          props.addCardsWithMaxAmountLess(primaryCardData, backupCardData, deleteCardInfo, fromCS);
        }

      }
    }
  }

  function showBackupReplacementConfirm(cardProps) {
    updateDeleteRetailPrimaryData(cardProps);
    updateAddBackupWhileDeletingRetailPrimary(true);
    updateShowAddNewBackupCard(false);
    updateShowReplacementConfirmModal(true);
  }

  function selectPrimaryConfirmed() {
    updateShowSelectPrimaryCardAlert(false);
    if (cardsDetails && cardsDetails.extraCards && cardsDetails.extraCards.retail) {
      updateCardsToSelectFrom(cardsDetails.extraCards.retail);
      updateShowSelectPrimaryCard(true);
    }
    analyticsService.analyticsProcessEvent({
      "event": "modal_click_generic",
      "context": {
        "event_action": "select card",
        "event_detail": {
          "modal": "Select another default card modal"
        }  
      }
    });
  }

  function savePrimaryClicked(primaryCard) {
    updateShowSelectPrimaryCard(false);
    updateLoading(true);
    const saveInfo = getSimpleSaveCardInfo(primaryCard, true, false);
    const deleteCardInfo = getDeleteCardInfo(currentEditCard);
    props.simpleSaveCard(saveInfo, deleteCardInfo, fromCS);
  }

  function addReplacementPrimaryAlertAccepted() {
    updateShowAddReplacementPrimaryCardAlert(false);
    updateShowPaymentCardRequiredAlert(false);
    updateShowAddReplacementPrimaryCard(true);
  }

  // when deleting a primary card and adding a new primary card
  function addReplacementPrimaryCard(cardProps) {
    updateShowAddReplacementPrimaryCard(false);
    updateShowAddReplacementBackupCard(false);
    if (cardProps.isFederal || cardProps.isCommuter) {
      updateReplacingRetailPrimaryCardwithBenefit(true);
      //no cards already on file and federal card is being added
      // need to add condition to check if Max AuthAmount is greater/less tahn show backupcard
      var subscriptionAmount =  props.subscriptionAmount ? Math.round(parseFloat(props.subscriptionAmount)) : 0;
      if( subscriptionAmount && cardProps.maxAuthorizedAmount && cardProps.maxAuthorizedAmount <  subscriptionAmount){
        updateMaxAuthorizedAmountIsLess(true);
      }
      updateLoading(true);
      setVerifyApiInfo(cardProps);
      const deleteCardInfo = getDeleteCardInfo(currentEditCard);
      //saveCard(cardProps, deleteCardInfo);
      if(currentEditCard.isPrimary && (currentEditCard.isCommuterBenefitCard || currentEditCard.isFederalBenefitCard)){
        updateEditDeleteFederal(true);
        var editDeleteFederal = true;
        saveCard(cardProps, null, editDeleteFederal);
      }else{
        saveCard(cardProps, deleteCardInfo);
      }
     // updateShowAddReplacementBackupCard(true); // removed for api call check //need to check API if backup card is required
    } else {
      updateLoading(true);
      const deleteCardInfo = getDeleteCardInfo(currentEditCard);
      saveCard(cardProps, deleteCardInfo);
    }
  }

  function showAddReplacementConfirm(cardProps) {
    updateDeleteRetailPrimaryData(cardProps);
    updateShowAddReplacementPrimaryCard(false);
    updateShowAddReplacementBackupCard(false);
    updateShowReplacementConfirmModal(true);
  }

  function addCardWhileDeletingRetailPrimary() {
    updateShowReplacementConfirmModal(false);
    var cardProps = deleteRetailPrimaryData;
    if(addBackupWhileDeletingRetailPrimary){
        addNewBackupCard(cardProps);
    }else{
      addReplacementPrimaryCard(cardProps);
    }
  }

  async function addReplacementBackupCard(cardProps) {
    updateLoading(true);
    updateShowAddReplacementBackupCard(false);
    const backupCardInfo = getCardInfo(cardProps);
    const backupVerifyInfo = getSaveCardAPIInfo(backupCardInfo);
    const backupApiInfo = getAddCardAPIInfo(backupCardInfo);
    const primaryCardData = await verifyCard(primaryCardVerifyInfo, primaryCardApiInfo);
    const backupCardData = await verifyCard(backupVerifyInfo, backupApiInfo);
    if (!isEmpty(primaryCardData) && !isEmpty(backupCardData)) {
      const deleteCardInfo = getDeleteCardInfo(currentEditCard);
      props.addCards(primaryCardData, backupCardData, deleteCardInfo, fromCS, deletingRetailPrimary, maxAuthorizedAmountIsLess );
    }
  }

  function selectBackupAsPrimaryAlertConfirmed() {
    updateShowSelectBackupAsPrimaryAlert(false);
    if (cardsDetails && cardsDetails.extraRetailWithBackupCards && cardsDetails.extraRetailWithBackupCards.length) {
      updateCardsToSelectFrom(cardsDetails.extraRetailWithBackupCards);
      updateShowSelectBackupAsPrimary(true);
    }
    analyticsService.analyticsProcessEvent({
      "event": "modal_click_generic",
      "context": {
        "event_action": "select card",
        "event_detail": {
          "modal": "Select another default card modal"
        }  
      }
    });
  }

  function saveBackupAsPrimaryClicked(selectedCard) {
    updateLoading(true);
    updateShowSelectBackupAsPrimary(false);
    const saveInfo = getSimpleSaveCardInfo(selectedCard, false, true);
    const deleteCardInfo = getDeleteCardInfo(currentEditCard);
    props.simpleSaveCard(saveInfo, deleteCardInfo, fromCS);
  }

  function analyticsClick(){
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "add payment"
      }
    });
  }

  function analyticsClickClose(){
    analyticsService.analyticsProcessEvent({
      "event": "modal_click_generic",
      "context": {
        "event_action": "cancel",
        "event_detail": {
          "modal": "delete card? modal"
        }  
      }
    });
  }

  function addCardClose(data){
    analyticsService.analyticsProcessEvent({
      "event": "modal_click_generic",
      "context": {
        "event_action": "cancel",
        "event_detail": {
          "modal": data ? "Add another backup card" : "add another card"
        }  
      }
    });
  }

  useEffect(() => {
    if (props.driverStatus && props.driverStatus.toLowerCase().includes('pending')) {
      updateDriverPending(true);
    }
  }, [props.driverStatus])

  function CheckSecondarCardRequired() {
    const payload = {
      packageName: props.selectedPlan.packageName,
      packageDiscountType: props.selectedPlan.role,
      employerId: props.employerId,
    }
    updateSecondryCardLoading(true);
    props.checkIfSecondaryCardIsRequired(payload);
  }

  useEffect(() => {
    if(props.secondryCardLoading){
      updateSecondryCardLoading(false);
      if(props.secondaryCardIsRequired){
        updateShowSCRPopup(true);
        analyticsService.analyticsProcessEvent({
          "event": "modal_view_generic",
          "context": {
              "event_action": "subscription cost exceeds benefit card maximum modal"
          }
      });
      }else{
        if(!props.secondaryCardCheckError){
          props.updateSecondaryCardLoading();
          if(props.history && props.history.location && props.history.location.state && props.history.location.state.licenseNotification ){
            if(isDriverPending){
              props.getDocusignContract(true, props.profile.vanpoolId, props.history, '/myprofile/change/plan/summary'); //check if need to go to driver summary or normal summary
            } else {
            props.history.push("/myprofile/change/plan/licenseNotification");
            }
          }else{
            props.getDocusignContract(false, props.profile.vanpoolId, props.history, '/myprofile/change/plan/summary');
          }
        }
      }
    }

  },[props.secondaryCardIsRequired, props.secondryCardLoading])

  function getPrimaryCardDetails() {
    const cardDetails = getCardDetails(props.payment.cards);
    if( cardDetails && cardDetails.primaryCards && cardDetails.primaryCards[0]){
      return cardDetails.primaryCards[0]
    }
  }

  return (
    <div className='payment-cards-page'>
      <div className='container'>
      <Loading isLoading={secondryCardLoading} />
        <div className='header'>
          <div className='backArrow'>
            <Link className="overview-link" onClick={props.history.goBack}>
              <img src={ArrowLeft} alt='go back' role='button'></img>
            </Link>
          </div>
          <div className='heading'>Payment Cards</div>
        </div>
        <div className='main'>
          <div className='payment-heading'>Manage your payment information for credit, debit, federal benefit card or commuter benefit card</div>
          <span aria-live='assertive' className='card-loader-container'>
            {loading && <div className="card-loader" aria-busy='true' role='alert'><span className='hide'>Loading Payment Cards</span>
            </div>}
          </span>
          { !loading && <div className='card-list-container'>
            {payments && payments.length === 4 && <CardMessage message="You can have a maximum of 4 cards on file. Please delete a card to add a new one." />}
            {
              payments && payments.length > 0 && payments.map(card => {
                if (card) {
                  const isExpired = isCardExpired(card.expirationMMYY);
                  const badgeClass = isExpired ? 'expired' : (card.isPrimary ? 'primary' : (card.isBackup ? 'backup' : ''));
                  const badgeText = isExpired ? 'Expired' : (card.isPrimary ? 'Default' : (card.isBackup ? 'Secondary' : ''));
                  return (
                    <CardBox
                      card={card}
                      editCard={editCard}
                      isExpired={isExpired}
                      badgeClass={badgeClass}
                      badgeText={badgeText}
                      key={card.partialAccountNumber + card.cardBrand}
                    />)
                }
              }
              )
            }
          </div>}
          <ToastMessage />
          <div className='add-payment'>
            {
              payments.length < 4 && !loading && !isVanCancelled
                ? <div className='button-container'>
                  <button className='add-button' onClick={() => { updateShowAddCard(true); analyticsClick()}}>  <img src={AddIcon} aria-hidden='true'/>Add Payment</button>
                </div>
                : null
            }
          </div>
          {
            props.history && props.history.location && props.history.location.state && props.history.location.state.fromChangeSubscription &&
            <div className='continue-for-change-subscription'>
               <button className='continue-button' onClick={() => CheckSecondarCardRequired()}>Continue</button>
            </div>
          }
        </div>
      </div>
      {showAddCard && <div className="card-popup show">
        <AddCard cardDetails={cardsDetails} reference={addCardNode} binNumbers={props.binNumbers}  binNumberArray={props.binNumberArray} addCard={addCard} maxAmount={props.maxAmount} close={() => updateShowAddCard(false)} />
      </div>}
      {
        showAddBackupCard && <div className="card-popup show">
          <BackupCard
           PrimaryCardDetails={getPrimaryCardDetails()}
            heading='Add a Secondary card'
            text='In case your benefit card does not have enough funds to cover monthly charges, please add a secondary card.'
            reference={addBackupCardNode} binNumbers={props.binNumbers} addCard={addBackupCard} binNumberArray={props.binNumberArray}  />
        </div>
      }
      {
        showEditCard && <div className="card-popup show">
          <EditCard cardDetails={cardsDetails} reference={editCardNode} card={currentEditCard} close={() => updateShowEditCard(false)} saveEditedCard={saveEditedCard} deleteClicked={deleteClicked} maxAmount={props.maxAmount}/>
        </div>
      }

       {/* below code is not required, we can delete it  */}
      {
        showBackupCard && <div className="card-popup show">
          <SelectCard
            heading='Select a secondary card'
            text='You must select a secondary card'
            reference={selectBackupNode}
            cards={cardsToSelectFrom}
            saveClicked={saveClicked}
            close={() => updateShowBackupCard(false)} />
        </div>
      }
      {
        showDeleteCardAlert && <div className='card-popup show'>
          <ConfirmationPopup
            heading='Delete Card?'
            text='Deleting this card will also remove all of its data'
            confirmButtonText='delete card'
            reference={deleteCardNode} close={() => {updateShowDeleteCardAlert(false); analyticsClickClose()}} confirm={deleteConfirmed} />
        </div>
      }
      {
        showSelectBackupCard && <div className="card-popup show">
          <SelectCard
            heading={`${ (addingNewbenefitCard ||  isEditScenario) ? 'Select a secondary card' : 'Select a secondary card'}`}
            text={`${ (addingNewbenefitCard || isEditScenario) ? "You must select a secondary card before you can update this one" : "You must select a secondary card before you can update this one"}`}
            reference={selectBackupNode1}
            cards={cardsToSelectFrom}
            saveClicked={saveBackupClicked}
            close={() => updateShowSelectBackupCard(false)} />
        </div>
      }
      {
        showSelectCardAlert && <div className='card-popup show'>
          <ConfirmationPopup
            heading={`${ (addingNewbenefitCard ||  isEditScenario) ? 'Select a secondary card' : 'Select a secondary card'}`}
            text={`${ (addingNewbenefitCard || isEditScenario) ? "You must select a secondary card before you can update this one" : "You must select a secondary card before you can update this one"}`}
            confirmButtonText='Select card'
            cardType='backup'
            reference={selectCardAlertNode} 
            close={() => {
              analyticsService.analyticsProcessEvent({
                "event": "modal_click_generic",
                "context": {
                  "event_action": "cancel",
                  "event_detail": {
                    "modal": "Select another backup card modal"
                  }  
                }
              });
             updateShowSelectCardAlert(false)}
             } confirm={selectConfirmed} />
        </div>
      }
      {
        // changing the text to remove 'another' word as part of add scenario and also 'delete'
        showAddBackupAlert && <div className='card-popup show'>
          <ConfirmationPopup
            heading={` ${(addingNewbenefitCard || isEditScenario) ? "Add a secondary card" : "Add a secondary card"} `}
            text={` ${ (addingNewbenefitCard || isEditScenario) ? "To proceed please add a secondary payment card to cover the recurring subscription cost" :  "You must add a secondary card before you can update this one"}`}
            confirmButtonText='Add card'
            reference={addBackupAlertNode} close={() => { updateShowAddBackupAlert(false); addCardClose(true)}} confirm={addBackupAlertConfirmed} />
        </div>
      }

      {/* adding backup card when deleting federal card and backup  card is required */}

      {
        showAddBackupAlertWhenDeletingFederal && <div className='card-popup show'>
          <ConfirmationPopup
            heading='Add a secondary card'
            text='You must add a secondary card before you can update this one'
            confirmButtonText='Add card'
            reference={addBackupAlertNode} close={() => { updateShowAddBackupAlertWhenDeletingFederal(false); addCardClose(true)}} confirm={addBackupAlertConfirmed} />
        </div>
      }

      {
        showAddNewBackupCard && <div className="card-popup show">
          <BackupCard
            PrimaryCardDetails={getPrimaryCardDetails()}
            heading='Add Payment'
            reference={addNewBackupCardNode} binNumbers={props.binNumbers} addCard={addNewBackupCard} binNumberArray={props.binNumberArray} 
            deletingRetailPrimary={deletingRetailPrimary}
            showBackupReplacementConfirm={showBackupReplacementConfirm}
            close={() => updateShowAddNewBackupCard(false)}
          />
        </div>
      }
      {
        showSelectPrimaryCardAlert && <div className='card-popup show'>
          <ConfirmationPopup
            heading='Select a default card'
            text={"You must select a default card before you can update this one"}
            confirmButtonText='select card'
            cardType='default'
            reference={selectPrimaryCardAlertNode}
             close={() => {
              analyticsService.analyticsProcessEvent({
                "event": "modal_click_generic",
                "context": {
                  "event_action": "cancel",
                  "event_detail": {
                    "modal": "Select another default card modal"
                  }  
                }
              });
              updateShowSelectPrimaryCardAlert(false)}
              } 
              confirm={selectPrimaryConfirmed} />
        </div>
      }
      {
        showSelectPrimaryCard && <div className="card-popup show">
          <SelectCard
            heading='Select a default card'
            text={"You must select a default card before you can update this one"}
            reference={selectPrimaryCardNode}
            cards={cardsToSelectFrom}
            saveClicked={savePrimaryClicked}
            close={() => updateShowSelectPrimaryCard(false)} />
        </div>
      }
      {
        showAddReplacementPrimaryCardAlert && <div className='card-popup show'>
          <ConfirmationPopup
            heading='Add a card'
            text='There must be at least one card on file for an active subscription. You must add a card before you can update this one.'
            confirmButtonText='add card'
            reference={AddReplacementPrimaryCardAlertNode} close={() => { updateShowAddReplacementPrimaryCardAlert(false);addCardClose()}} confirm={addReplacementPrimaryAlertAccepted} />
        </div>
      }
      {
        showPaymentCardRequiredAlert && <div className='card-popup show'>
          <ConfirmationPopup
            heading='Payment method required'
            text='To continue your subscription, you will need to add another payment card before removing this one.'
            confirmButtonText='Add New Card'
            showAssistance={true}
            reference={ShowPaymentCardRequiredAlertNode} close={() => { updateShowPaymentCardRequiredAlert(false);}} confirm={addReplacementPrimaryAlertAccepted} />
        </div>
      }
      {
        showMakeOriginalRetailAlert && <div className='card-popup show'>
          <MakeOriginalRetailAsBackup
            heading='Your benefit card won’t cover your subscription'
            text='To proceed, please select your original payment card as a secondary payment method or add a new card to cover your monthly subscription'
            confirmButtonText='continue'
            cards={cardsToSelectFrom}
            reference={ShowMakeOriginalRetailAlertNode}
            close={() => { updateShowMakeOriginalRetailAlert(false);}} 
            AddPayment={() =>{updateShowMakeOriginalRetailAlert(false);updateShowAddNewBackupCard(true);}}
            confirm={saveBackupClicked} />
        </div>
      }
      {showAddReplacementPrimaryCard && <div className="card-popup show">
        <AddCard
          isDeleteScenario={true}
          cardDetails={cardsDetails}
          reference={AddReplacementPrimaryCardNode}
          binNumbers={props.binNumbers}
          binNumberArray={props.binNumberArray}
          addCard={addReplacementPrimaryCard}
          maxAmount={props.maxAmount}
          deletingRetailPrimary={deletingRetailPrimary}
          showAddReplacementConfirm={showAddReplacementConfirm}
          close={() => updateShowAddReplacementPrimaryCard(false)} />
      </div>}
      {
        showAddReplacementBackupCard && <div className="card-popup show">
          <BackupCard
            PrimaryCardDetails={newReplacementPrimaryCardDetails}
            isDeleteScenario={true}
            heading='Add a secondary card'
            text={`In case your benefit card does not have enough funds to cover monthly charges, please add a secondary card.`}
            reference={AddReplacementBackupCardNode} binNumbers={props.binNumbers} addCard={addReplacementBackupCard} binNumberArray={props.binNumberArray}  />
        </div>
      }
      {
        showSelectBackupAsPrimaryAlert && <div className='card-popup show'>
          <ConfirmationPopup
            heading='Select a default card'
            text={"You must select a default card before you can update this one."}
            confirmButtonText='select card'
            cardType='default'
            reference={selectBackupAsPrimaryAlertNode}
            close={() => {
              analyticsService.analyticsProcessEvent({
                "event": "modal_click_generic",
                "context": {
                  "event_action": "cancel",
                  "event_detail": {
                    "modal": "Select another default card modal"
                  }  
                }
              });
             updateShowSelectBackupAsPrimaryAlert(false)}}
            confirm={selectBackupAsPrimaryAlertConfirmed} />
        </div>
      }
      {
        showSelectBackupAsPrimary && <div className="card-popup show">
          <SelectCard
            heading='Select a default card'
            text='You must select a default card before you can update this one'
            reference={selectBackupAsPrimaryCardNode}
            cards={cardsToSelectFrom}
            message="Your secondary card is automatically selected to become your default payment method. You can choose a different card now or  change this later."
            saveClicked={saveBackupAsPrimaryClicked}
            close={() => updateShowSelectBackupAsPrimary(false)} />
        </div>
      }
      {
          showSCRPopup && <SecondaryCardNoticePopup close={() => updateShowSCRPopup(false)}  history={props.history} updateSecondaryCardModal={() => props.updateSecondaryCardModal()}  showCloseButton={true}/>
      }
      {
        showReplacementConfirmModal && <CardReplacementConfirmPopup onContinue={() => addCardWhileDeletingRetailPrimary()}  close={() => updateShowReplacementConfirmModal(false)}/>
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    payment: state.payments,
    binNumbers: state.paymentHistory.generalInfo.binNumbers,
    paymentDetailsLoaded: state.payments.loaded,
    maxAmount: state.paymentHistory.generalInfo.maxAmount,
    profile: state.profile,
    isProfileLoaded: state.profile.isLoaded,
    loadError: state.PaymentOverview.loadError,
    loadErrorString: state.PaymentOverview.loadErrorString,
    selectedPlan: state.profile.selectedPlan,
    employerId: state.profile.employerId,
    secondaryCardIsRequired: state.profile.secondaryCardIsRequired,
    secondryCardLoading: state.profile.secondaryCardCheckCompleted,
    secondaryCardCheckError: state.profile.secondaryCardCheckError,
    showCardAlert: state.payments.showCardAlert,
    driverStatus: state.profile.driverUpdatedStatus,
    binNumberArray: state.paymentHistory.generalInfo.binNumberArray,
    subscriptionAmount: state.profile.subscription.totalAmount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    init() {
      dispatch({ type: actionTypes.PAYMENT_DETAILS_LOADING });
    },
    getBINNumbers() {
      dispatch({ type: actionTypes.GET_BIN_NUMBERS });
    },
    saveCard(verifyCardInfo, apiCardInfo, deleteCard, fromCS, editDeleteFederal) {
      dispatch({ type: actionTypes.ADD_PAYMENT_CARD, verifyCardInfo, apiCardInfo, deleteCard, fromCS, editDeleteFederal });
    },
    addCards(primaryCard, backupCard, deleteCard, fromCS, deletingRetailPrimary, maxAuthorizedAmountIsLess) {
      dispatch({ type: actionTypes.ADD_BOTH_CARDS_TOGETHER, primaryCard, backupCard, deleteCard, fromCS, deletingRetailPrimary, maxAuthorizedAmountIsLess })
    },
    saveEditedCard(cardData, fromCS) {
      dispatch({ type: actionTypes.SAVE_EDITED_CARD, data: cardData, fromCS })
    },
    saveBackupWhenEditingCard(primaryCard, backupCard, fromCS, selectBackup) {
      dispatch({ type: actionTypes.SAVE_EDITED_CARD_WITH_BACKUP, primaryCard, backupCard, fromCS, selectBackup })
    },
    deleteCard(cardData, fromCS) {
      dispatch({ type: actionTypes.DELETE_CARD, data: cardData, fromCS })
    },
    simpleSaveCard(saveCard, deleteCard, fromCS) {
      dispatch({ type: actionTypes.SIMPLE_SAVE_CARD, data: saveCard, deleteCard, fromCS })
    },
    loadProfile() {
      dispatch({ type: actionTypes.USER_PROFILE_LOADING, loadParticipants: true  });
    },
    checkIfSecondaryCardIsRequired(payload) {
      dispatch({ type: actionTypes.CHECK_SECONDARY_CARD_REQUIRED, data: payload})
    },
    updateSecondaryCardLoading() {
      dispatch({ type: actionTypes.UPDATE_SECONDARY_CARD_LOADING})
    },
    updateSecondaryCardModal() {
      dispatch({ type: actionTypes.SECONDARY_CARD_IS_REQUIRED, data:  {isRequired: false, checkCompleted: false} })
    },
    getDocusignContract(isDriver, vanpoolId, history, navigateTo) {
      dispatch({ type: actionTypes.APPLY_TO_SIGN_CONTRACT, data: { isDriver: isDriver, vanpoolId: vanpoolId, history, navigateTo } })
    },
    updateShowCardAlert(data){
      dispatch({
        type: actionTypes.SHOW_CARD_ALERT, data: data });
    },
    addCardsWithMaxAmountLess(primaryCard, backupCard, deleteCard, fromCS, selectBackup, editDeleteFederal) {
      dispatch({ type: actionTypes.ADD_BOTH_CARDS_TOGETHER_WITH_MAX_AMOUNT, primaryCard, backupCard, deleteCard, fromCS, selectBackup, editDeleteFederal })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentCards);
